import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c818ca4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-account-page overflow-x-hide" }
const _hoisted_2 = { class: "container no-padding" }
const _hoisted_3 = { class: "row no-margin" }

import { sessionStorageKeys } from "@/utils/constants";
import {
  computed,
  nextTick,
  onBeforeUnmount,
  onBeforeUpdate,
  onMounted,
  ref,
  watch,
} from "vue";
import ResetPasswordHeader from "./resetPassword/resetPasswordHeader.vue";
import ResetPasswordContain from "./resetPassword/resetPasswordContain.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'resetPassword',
  setup(__props) {

const dyn_height = ref("0");
const windowHeight = ref("");

const onResize = () => {
  dyn_height.value = (window.innerHeight + "px") as string;
  windowHeight.value = "" + window.innerHeight + "px !important ";
};

onMounted(() => {
  nextTick(() => {
    window.addEventListener("resize", onResize);
    onResize();
  });
});

onBeforeUnmount(() => {
  sessionStorage.removeItem(sessionStorageKeys.passwordResetToken);
  const bodyElement = document.querySelector("body");

  if (bodyElement && bodyElement.classList.contains("page-opacity")) {
    bodyElement.classList.remove("page-opacity", "page-bg", "page-shadow");
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ResetPasswordHeader, {
          "dyn-height": dyn_height.value,
          "window-height": windowHeight.value
        }, null, 8, ["dyn-height", "window-height"]),
        _createVNode(ResetPasswordContain)
      ])
    ])
  ]))
}
}

})